import { Container, IDestroyOptions, Point, Sprite, Texture } from "pixi.js";
import { HourlyBonusResourcePackage } from "../../resources/HourlyBonusResourcePackage";

export class LightsBgContainer extends Container {
    private readonly LIGHTS_VIEW_DESCRIPTION = new Array<LightViewDescription>();

    public constructor(
        fortuneWheelResources: HourlyBonusResourcePackage
    ) {
        super();
        this.LIGHTS_VIEW_DESCRIPTION = new Array<LightViewDescription>(
            { position: new Point(350, -250), scale: 0.7, angle: -15, skew: 0, texture: fortuneWheelResources.assets_views_hourly_bonus_golden_wheel_bg_light_png },
            { position: new Point(280, -20), scale: 1, angle: -15, skew: 0, texture: fortuneWheelResources.assets_views_hourly_bonus_golden_wheel_bg_light_png },
            { position: new Point(-350, -250), scale: 0.7, angle: -164, skew: 3.14, texture: fortuneWheelResources.assets_views_hourly_bonus_golden_wheel_bg_light_png },
            { position: new Point(-275, -20), scale: 1, angle: -164, skew: 3.14, texture: fortuneWheelResources.assets_views_hourly_bonus_golden_wheel_bg_light_png }
        );
        this.build();
    }

    private build(): void {
        this.LIGHTS_VIEW_DESCRIPTION.forEach((item) => {
            const light = new Sprite(item.texture);
            light.anchor.set(0.5, 0.5);
            light.skew.x = item.skew;
            light.scale.set(item.scale);
            light.angle = item.angle;
            light.position.set(item.position.x, item.position.y);
            this.addChild(light);
        });
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

type LightViewDescription = {
    position: Point;
    scale: number;
    angle: number;
    skew: number;
    texture: Texture;
}
